module.exports = __webpack_public_path__ + "img/logout.c20fa743.svg";